import React, { Component } from "react";
import { Button } from "reactstrap";
import { MissionStep as MissionStepDto, MissionStepType } from "../generated";

export interface Props {
  type: MissionStepType;
  presented: string;
  context: MissionStepDto;
  callback: () => void;
}

export class MissionStep extends Component<Props, {}> {
  render() {
    return (
      <div>
        <p>
          Please verify, by comparing to what you can see at your provider, that
          the following data is correct
        </p>
        <Button color="danger">Not quite right</Button>{" "}
        <Button color="success">Correct</Button>
      </div>
    );
  }
}
